import Color from '@/Enums/Color.enum';
import { Button, ButtonProps } from '@mui/material';

const ApplyLoadingButton = (props: ButtonProps) => (
  <Button
    loadingPosition='end'
    variant='contained'
    sx={{ height: '37px', width: '130px', background: Color.Primary }}
    {...props}
  >
    Apply
  </Button>
);

export default ApplyLoadingButton;
